import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

window.onload = function () {
  if (localStorage.getItem("cacheVersion") !== "2.2") {
    console.log("triggered");
    localStorage.setItem("cacheVersion", "2.2");
    window.location.reload();
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
